import { render, staticRenderFns } from "./Swiper2.vue?vue&type=template&id=44215702&scoped=true&"
import script from "./Swiper2.vue?vue&type=script&lang=js&"
export * from "./Swiper2.vue?vue&type=script&lang=js&"
import style0 from "./Swiper2.vue?vue&type=style&index=0&id=44215702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44215702",
  null
  
)

export default component.exports